import React from "react";
import {
    baseVariantSelector,
    rootProductSelector,
} from "tsi-common-react/src/apps/configurator/selectors";
import { useAppSelector } from "tsi-common-react/src/store/reducers";

import { OutOfContextBundleCollection as OutOfContextBundleCollectionComponent } from "../OutOfContextBundleCollection";

export const OutOfContextBundleCollection = (): React.JSX.Element => {
    const rootProduct = useAppSelector((state) =>
        rootProductSelector(state.configurator),
    );
    const baseVariant = useAppSelector((state) =>
        baseVariantSelector(state.configurator),
    );
    const bundles = useAppSelector(
        (state) => state.configurator.entities.concreteBundles,
    );

    return (
        <OutOfContextBundleCollectionComponent
            rootProduct={rootProduct}
            baseVariant={baseVariant}
            bundles={bundles}
        />
    );
};
